/* <bip-tabs>: WAI-ARIA tabs on wide screens (>= 750px), accordion on mobile.
 * Without JS every panel is visible (progressive enhancement). */
(function () {
  if (!window.customElements || customElements.get('bip-tabs')) return;
  var MQ = window.matchMedia('(min-width: 750px)');

  class BipTabs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.list = this.querySelector('[role="tablist"]');
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.accs = Array.prototype.slice.call(this.querySelectorAll('.bip-tabs__acc'));
      this.panels = this.accs.map(function (b) { return document.getElementById(b.getAttribute('aria-controls')); });
      this.active = 0;
      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.select(i, true); });
        tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
      });
      this.accs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { self.toggle(i); });
      });
      this._mode = this.mode.bind(this);
      if (MQ.addEventListener) MQ.addEventListener('change', this._mode); else MQ.addListener(this._mode);
      this.mode();
    }

    disconnectedCallback() {
      if (MQ.removeEventListener) MQ.removeEventListener('change', this._mode); else MQ.removeListener(this._mode);
      this._init = false;
    }

    mode() {
      var tabsMode = MQ.matches;
      this.classList.toggle('bip-tabs--tabs', tabsMode);
      this.list.hidden = !tabsMode;
      var self = this;
      this.panels.forEach(function (p, i) {
        if (tabsMode) {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', self.tabs[i].id);
          p.hidden = i !== self.active;
        } else {
          p.setAttribute('role', 'region');
          p.setAttribute('aria-labelledby', self.accs[i].id);
          var open = self.accs[i].getAttribute('aria-expanded') === 'true';
          p.hidden = !open;
        }
      });
    }

    select(i, focus) {
      this.active = i;
      this.tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, k) { p.hidden = k !== i; });
      // accordion (mobile) state is independent: all sections start closed
      if (focus) this.tabs[i].focus();
    }

    toggle(i) {
      var btn = this.accs[i];
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.panels[i].hidden = !open;
      if (open) this.active = i;
    }

    onKey(e, i) {
      var n = this.tabs.length, j = null;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j === null) return;
      e.preventDefault();
      this.select(j, true);
    }
  }

  customElements.define('bip-tabs', BipTabs);
})();
